module.exports = "<div class=\"logout\">\r\n  <h1>Abmelden</h1>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = ./src/app/components/logout/logout.component.html
// module chunks = main